
// import React, { useState, useEffect } from "react";
// import {
//   Container,
//   Grid,
//   CardContent,
//   Typography,
//   Box,
//   CircularProgress,
//   Divider,
//   Card,
//   Button,
// } from "@mui/material";
// import { styled } from "@mui/material/styles";
// import { MdOutlineError } from "react-icons/md";
// import { FaAward, FaSadTear, FaChalkboardTeacher } from "react-icons/fa";
// import { motion } from "framer-motion";

// // Styled components
// const AnimatedCard = styled(motion.div)(({ theme }) => ({
//   borderRadius: "16px",
//   overflow: "hidden",
//   boxShadow: "0 8px 20px rgba(0,0,0,0.2)",
//   transition: "transform 0.3s",
//   background: "linear-gradient(to bottom, rgb(1, 23, 32), rgb(1, 45, 65))",
//   padding: theme.spacing(3),
//   marginTop: theme.spacing(3),
//   color: "white", // White text
//   "&:hover": {
//     transform: "translateY(-10px)",
//   },
//   height: "100%", // Set fixed height for consistency
// }));

// const IconWrapper = styled(Box)(({ color }) => ({
//   fontSize: "2.5rem",
//   color: color,
//   display: "flex",
//   justifyContent: "center",
//   alignItems: "center",
//   marginBottom: "12px",
// }));

// const SectionTitle = styled(Typography)({
//   fontWeight: "bold",
//   color: "#fff",
//   marginTop: "62px",
//   marginBottom: "16px",
//   textAlign: "center",
// });

// const ErrorCard = styled(Card)(({ theme }) => ({
//   padding: theme.spacing(4),
//   textAlign: "center",
//   backgroundColor: "#fbe9e7",
//   borderRadius: "16px",
//   boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
//   color: "#333", // Text color
// }));

// const StudentStatus = () => {
//   const [data, setData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");

//   useEffect(() => {
//     const fetchDetails = async () => {
//       setLoading(true);
//       setError("");

//       try {
//         const userId = localStorage.getItem("user_id");
//         if (!userId) {
//           throw new Error("User ID not found in local storage");
//         }

//         const response = await fetch(
//           `https://newbackend.elephant-tank.com/api/project_info/?stud_id=${userId}`
//         );
//         if (!response.ok) {
//           throw new Error("Failed to fetch data");
//         }

//         const result = await response.json();
//         setData(result);
//       } catch (err) {
//         setError(err.message || "An error occurred while fetching data");
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchDetails();
//   }, []);

//   if (loading) {
//     return (
//       <Box
//         display="flex"
//         justifyContent="center"
//         alignItems="center"
//         height="100vh"
//       >
//         <CircularProgress size={70} />
//       </Box>
//     );
//   }

//   if (!data) {
//     return (
//       <Container maxWidth="sm" style={{ marginTop: "80px" }}>
//         <ErrorCard>
//           <IconWrapper color="#e53935">
//             <MdOutlineError />
//           </IconWrapper>
//           <Typography variant="h6" fontWeight="bold" gutterBottom>
//             You have not uploaded any project
//           </Typography>
//           <Typography variant="body2" color="textSecondary">
//             Please upload project details to view your status.
//           </Typography>
//         </ErrorCard>
//       </Container>
//     );
//   }

//   return (
//     <Container maxWidth="lg" style={{ padding: "16px", marginTop: "40px" }}>
//       <SectionTitle variant="h5">Your Submitted Idea</SectionTitle>

//       <Grid container spacing={3}>
//         {/* Left Column */}
//         <Grid item xs={12} md={6}>
//           <AnimatedCard
//             initial={{ opacity: 0, y: 20 }}
//             animate={{ opacity: 1, y: 0 }}
//             transition={{ duration: 0.5 }}
//           >
//             <CardContent>
//               <Box textAlign="center">
//                 <IconWrapper color="#7b1fa2">
//                   <FaChalkboardTeacher />
//                 </IconWrapper>
//                 <Typography variant="h6" fontWeight="bold" gutterBottom>
//                   {data.idea_data.project_type}
//                 </Typography>

//                 <Box mt={2} mb={2}>
//                   <Typography variant="body2" color="white" gutterBottom>
//                     <strong>Created At:</strong>{" "}
//                     {new Date(data.idea_data.created_at).toLocaleDateString()}
//                   </Typography>
//                   <Typography variant="body2" color="white" gutterBottom>
//                     <strong>Status:</strong> {data.idea_data.status}
//                   </Typography>
//                 </Box>

//                 <Divider sx={{ margin: "16px 0" }} />

//                 <Typography variant="h6" fontWeight="bold" gutterBottom>
//                   {data.idea_data.title}
//                 </Typography>
//                 <Typography
//                   variant="body2"
//                   color="white" // Set description text color to white
//                   gutterBottom
//                 >
//                   {data.idea_data.description}
//                 </Typography>

//                 <Box mt={2} display="flex" justifyContent="center" alignItems="center">
//                   <IconWrapper color="#ffb74d">
//                     <FaAward />
//                   </IconWrapper>
//                   {/* <Typography
//                     variant="body1"
//                     fontWeight="bold"
//                     style={{ marginLeft: "8px" }}
//                   >
//                     Score: {data.idea_data.ai_score || "-"}/100
//                   </Typography> */}
//                 </Box>
//               </Box>
//             </CardContent>
//           </AnimatedCard>
//         </Grid>

//         {/* Right Column */}
//         <Grid item xs={12} md={6}>
//           <AnimatedCard
//             initial={{ opacity: 0, y: 20 }}
//             animate={{ opacity: 1, y: 0 }}
//             transition={{ duration: 0.5 }}
//           >
//             <CardContent>
//               <Box textAlign="center">
//                 <Typography variant="h6" fontWeight="bold" gutterBottom>
//                   View Your Files
//                 </Typography>

//                 <Box mt={3}>
//                   <Button
//                     variant="contained"
//                     color="primary"
//                     href={data.idea_data.idea}
//                     target="_blank"
//                     sx={{ marginRight: 2 }}
//                   >
//                     View Idea Document
//                   </Button>
//                   <Button
//                     variant="contained"
//                     color="secondary"
//                     href={data.idea_data.ppt}
//                     target="_blank"
//                     sx={{ marginRight: 2 }}
//                   >
//                     View Presentation
//                   </Button>
//                   {data.idea_data.video_file && (
//                     <Button
//                       variant="contained"
//                       color="success"
//                       href={data.idea_data.video_file}
//                       target="_blank"
//                     >
//                       View Video
//                     </Button>
//                   )}
//                 </Box>

//                 <Box mt={3}>
//                   {data.idea_data.admin_approval ? (
//                     <Typography variant="body2" color="primary">
//                       <motion.div
//                         animate={{ scale: [1, 1.2, 1] }}
//                         transition={{ repeat: Infinity, duration: 0.6 }}
//                       >
//                         Idea Shortlisted!
//                       </motion.div>
//                     </Typography>
//                   ) : (
//                     <Typography variant="body2" color="secondary">
//                       <motion.div
//                         animate={{ scale: [1, 1.2, 1] }}
//                         transition={{ repeat: Infinity, duration: 0.6 }}
//                       >
//                         In Progress - Wait for Shortlisting
//                       </motion.div>
//                     </Typography>
//                   )}
//                 </Box>
//               </Box>
//             </CardContent>
//           </AnimatedCard>
//         </Grid>
//       </Grid>
//     </Container>
//   );
// };

// export default StudentStatus;
import React, { useState, useEffect } from "react";
import {
  Container,
  Grid,
  CardContent,
  Typography,
  Box,
  CircularProgress,
  Divider,
  Card,
  Button,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { MdOutlineError } from "react-icons/md";
import { FaAward, FaSadTear, FaChalkboardTeacher } from "react-icons/fa";
import { motion } from "framer-motion";

// Styled components
const AnimatedCard = styled(motion.div)(({ theme }) => ({
  borderRadius: "16px",
  overflow: "hidden",
  boxShadow: "0 8px 20px rgba(0,0,0,0.3)",
  background: "linear-gradient(to bottom, rgb(2, 32, 45), rgb(3, 55, 80))",
  padding: theme.spacing(4),
  marginTop: theme.spacing(3),
  color: "white",
  "&:hover": {
    transform: "translateY(-8px)",
  },
}));

const IconWrapper = styled(Box)(({ color }) => ({
  fontSize: "2.8rem",
  color: color,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  marginBottom: "14px",
}));

const TransparentButton = styled(Button)({
  backgroundColor: "rgba(255, 255, 255, 0.1)",
  border: "1px solid rgba(255, 255, 255, 0.5)",
  color: "white",
  padding: "10px 20px",
  "&:hover": {
    backgroundColor: "rgba(255, 255, 255, 0.2)",
  },
});

const SectionTitle = styled(Typography)({
  fontWeight: "bold",
  color: "#fff",
  marginTop: "50px",
  marginBottom: "20px",
  textAlign: "center",
});

const StudentStatus = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchDetails = async () => {
      setLoading(true);
      setError("");

      try {
        const userId = localStorage.getItem("user_id");
        if (!userId) throw new Error("User ID not found in local storage");

        const response = await fetch(
          `https://newbackend.elephant-tank.com/api/project_info/?stud_id=${userId}`
        );
        if (!response.ok) throw new Error("Failed to fetch data");

        const result = await response.json();
        setData(result);
      } catch (err) {
        setError(err.message || "An error occurred while fetching data");
      } finally {
        setLoading(false);
      }
    };
    fetchDetails();
  }, []);

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
        <CircularProgress size={70} />
      </Box>
    );
  }

  if (!data) {
    return (
      <Container maxWidth="sm" style={{ marginTop: "80px" }}>
        <Card style={{ padding: "30px", textAlign: "center", backgroundColor: "#fbe9e7", borderRadius: "16px" }}>
          <IconWrapper color="#e53935">
            <MdOutlineError />
          </IconWrapper>
          <Typography variant="h6" fontWeight="bold" gutterBottom>
            No Project Uploaded
          </Typography>
          <Typography variant="body2">Upload project details to view status.</Typography>
        </Card>
      </Container>
    );
  }

  return (
    <Container maxWidth="lg" style={{ padding: "20px", marginTop: "40px" }}>
      <SectionTitle variant="h5">Your Submitted Idea</SectionTitle>
      <Grid container spacing={4}>
        {/* Left Column */}
        <Grid item xs={12} md={6}>
          <AnimatedCard>
            <CardContent>
              <Box textAlign="center">
                <IconWrapper color="#7b1fa2">
                  <FaChalkboardTeacher />
                </IconWrapper>
                <Typography variant="h6" fontWeight="bold" gutterBottom>
                  {data.idea_data.project_type}
                </Typography>
                <Typography variant="body2" gutterBottom>
                  {/* <strong>Created At:</strong> {new Date(data.idea_data.created_at).toLocaleDateString()} */}
                </Typography>
                <Typography variant="body2">
                  <strong>Status:</strong> {data.idea_data.status}
                </Typography>
                <Divider sx={{ margin: "16px 0" }} />
                <Typography variant="h6" fontWeight="bold" gutterBottom>
                  {data.idea_data.title}
                </Typography>
                <Typography variant="body2" gutterBottom>
                  {data.idea_data.description}
                </Typography>
              </Box>
            </CardContent>
          </AnimatedCard>
        </Grid>
        {/* Right Column */}
        <Grid item xs={12} md={6}>
          <AnimatedCard>
            <CardContent>
              <Box textAlign="center">
                <Typography variant="h6" fontWeight="bold" gutterBottom>
                  View Your Files
                </Typography>
                <Box mt={3}>
                  <TransparentButton href={data.idea_data.idea} target="_blank">View Idea</TransparentButton>
                  <TransparentButton href={data.idea_data.ppt} target="_blank">View Presentation</TransparentButton>
                  {data.idea_data.video_file && (
                    <TransparentButton href={data.idea_data.video_file} target="_blank">View Video</TransparentButton>
                  )}
                </Box>
                <Box mt={3}>
                  {data.idea_data.admin_approval ? (
                    <Typography variant="body2" color="primary">Idea Shortlisted!</Typography>
                  ) : (
                    <Typography variant="body2" color="secondary">In Progress - Wait for Shortlisting</Typography>
                  )}
                </Box>
              </Box>
            </CardContent>
          </AnimatedCard>
        </Grid>
      </Grid>
    </Container>
  );
};

export default StudentStatus;
